import {IAppState, IFeatureToggles, initialFeatureToggles} from "./Helper";
import {StorageConstants} from "../../util/constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getHomeContent} from "../home/ActionCreators";
import {getFeatureToggles, getServerTime} from "./ActionCreators";

const initialValue: IAppState = {
    language: localStorage.getItem(StorageConstants.LANGUAGE) ?? "mk",
    serverTime: null,
    error: false,
    errorCode: undefined,
    featureToggles: Boolean(sessionStorage.getItem(StorageConstants.FEATURE_TOGGLES)) ? JSON.parse(sessionStorage.getItem(StorageConstants.FEATURE_TOGGLES)!) : initialFeatureToggles,
    spinTheWheelOpen: false,
}

const appSlice = createSlice({
    name: SliceNames.APP,
    initialState: initialValue,
    reducers: {
        changeLanguage: (state, action: PayloadAction<string>) => {
            localStorage.setItem(StorageConstants.LANGUAGE, action.payload)
            state.language = action.payload
        },
        setApplicationError: (state, action: PayloadAction<{ isError: boolean, statusCode: number | undefined }>) => {
            state.error = action.payload.isError
            state.errorCode = action.payload.statusCode
        },
        updateServerTime: (state) => {
            state.serverTime = state.serverTime ? new Date(new Date(state.serverTime).getTime() + 1000).toISOString() : null;
        },
        updateRequiredLogin: (state, action: PayloadAction<boolean>) => {
            const newState = {
                ...state.featureToggles,
                login_required: action.payload,
            }
            sessionStorage.setItem(StorageConstants.FEATURE_TOGGLES, JSON.stringify(newState))
            state.featureToggles = newState
        },
        toggleSpinTheWheel: (state, action: PayloadAction<boolean>) => {
            state.spinTheWheelOpen = action.payload
        }
    },
    extraReducers: builder => {
        builder.addCase(
            getServerTime.fulfilled, (state, action: PayloadAction<string>) => {
                state.serverTime = action.payload
            })
            .addCase(
                getHomeContent.rejected, (state) => {
                    state.serverTime = null
                })
            .addCase(
                getFeatureToggles.fulfilled, (state, action: PayloadAction<IFeatureToggles>) => {
                    const newFeatureToggles = {
                        ...initialFeatureToggles,
                        ...action.payload,
                    }
                    sessionStorage.setItem(StorageConstants.FEATURE_TOGGLES, JSON.stringify(newFeatureToggles))
                    state.featureToggles = newFeatureToggles
                })
            .addCase(
                getFeatureToggles.rejected, (state) => {
                    sessionStorage.removeItem(StorageConstants.FEATURE_TOGGLES)
                    state.featureToggles = initialFeatureToggles
                })
    }
})

export default appSlice.reducer

export const {
    changeLanguage,
    setApplicationError,
    updateServerTime,
    updateRequiredLogin,
    toggleSpinTheWheel
} = appSlice.actions